<template>
  <div class="container">
    <div class="table-header">
      <h1>Projects</h1>
    </div>

    <!--FilterTable :header="header" :data="allProjects" :columns="header" :columnWidths="colWidths" @rowClicked="printRow"></FilterTable>-->
    <Suspense>
      <template #default>
        <ProjectsTable></ProjectsTable>
      </template>
      <template #fallback>
        projects table still loading...
      </template>
    </Suspense>
  </div>
</template>

<script setup lang="ts">
import ProjectsTable from './Projects-table.vue'
</script>
